/**
 * Canonical user roles — mirrors backend/src/constants/roles.js.
 *
 * The four actors from project scope, plus the platform Admin. Admin, Analyst
 * and Principal sign in with credentials; Analyst/Principal are what the
 * scope's page-level permission rules gate on. Contact (anonymous submission)
 * and Developer (expiring QR link) never sign in.
 */
export const ROLES = Object.freeze({
  ADMIN: 'Admin',
  ANALYST: 'Analyst',
  PRINCIPAL: 'Principal',
  CONTACT: 'Contact',
  DEVELOPER: 'Developer',
});

export const ALL_ROLES = Object.freeze(Object.values(ROLES));

/** Roles that authenticate with credentials. */
export const CREDENTIAL_ROLES = Object.freeze([ROLES.ADMIN, ROLES.ANALYST, ROLES.PRINCIPAL]);

/**
 * Roles an Admin may assign in User Management. Contact and Developer are
 * excluded: they are unauthenticated actors with no credentialed account.
 */
export const ASSIGNABLE_ROLES = Object.freeze([ROLES.ADMIN, ROLES.ANALYST, ROLES.PRINCIPAL]);

export default ROLES;
